<template>
    <span :class="{'position-relative d-block': changeable}">
        <slot name="prefix"></slot>
        <template v-if="actions.length === 0">
            <AutomationActionSelect @select="onActionAdd" :type="type">
                <template v-slot:popover-trigger>
                    <span>
                        then
                    </span>
                    <span class="param empty">do something</span>
                </template>
            </AutomationActionSelect>
        </template>
        <template v-else>
            <span v-for="(action, idx) in actions" :key="idx + _.get(action, 'uuid')">
                <span v-if="!action || !action.name"
                      :class="{'position-relative d-block': changeable}">
                    <AutomationActionSelect @select="a => onActionSelect(idx, a)" :type="type">
                        <template v-slot:popover-trigger>
                            <span v-if="actions.length > 1">
                                and
                            </span>
                            <span class="param empty">do something</span>
                        </template>
                    </AutomationActionSelect>
                    <slot name="after-action" :idx="idx"></slot>
                </span>
                <AutomationEditorSentence
                    v-else
                    :class="{'position-relative d-block': changeable, 'mt-4': action.otherwise}"
                    :key="idx"
                    :sentence="getActionSentence(action)"
                    :recipeSection="recipeSection"
                    @change="({path, data}) => onActionsSentenceChange(idx, {path, data})">
                    <template v-slot:before>
                        <span v-if="idx === 0">
                            then
                        </span>
                        <template v-else-if="checkActionCanBeMarkedAsOtherwise(idx)">
                            <span class="pl-1">
                            </span>
                            <span @click="onOtherwiseToggle(idx)" class="param selected">
                                <template v-if="action.otherwise">otherwise</template>
                                <template v-else>and</template>
                            </span>
                        </template>
                        <span v-else-if="idx > 0">
                            and
                        </span>
                    </template>
                    <template v-slot:after>
                        <slot name="after-action" :idx="idx"></slot>
                    </template>
                </AutomationEditorSentence>
            </span>
        </template>
    </span>
</template>

<script>
import AutomationEditorSentence from '../sentence/AutomationEditorSentence'
import AutomationActionSelect from './AutomationActionSelect'
import {AutomationTypes} from '@/types/automations/types'
import {mapGetters} from 'vuex'
import {AutomationActionOperators, AutomationRecipeSection} from '@/types/automations'

export default {
    name: 'AutomationEditorActions',
    components: {AutomationActionSelect, AutomationEditorSentence},
    props: {
        type: {
            type: String,
            required: true,
            default: AutomationTypes.AUTOMATION
        },
        actions: { // Array<AutomationAction>
            type: Array,
            required: true
        },
        changeable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'activeTeamId'
        ]),

        recipeSection() {
            return AutomationRecipeSection.ACTION
        }
    },
    methods: {
        onActionAdd(action) {
            this.onActionSelect(this.actions.length, action)
        },

        onActionSelect(idx, action) {
            action.changeable = true
            this.$emit('change', {path: [idx], data: action})
        },

        onActionsSentenceChange(idx, {path, data}) {
            this.$emit('change', {path: [String(idx)].concat(path), data})
        },

        getActionSentence(action) {
            return {
                template: action.template,
                field: action.field,
                operator: action.operator,
                values: action.values
            }
        },

        getOperatorValue(action) {
            return _.get(action, 'operator.value') || _.get(action, 'operator.default')
        },

        checkActionCanBeMarkedAsOtherwise(idx) {
            const actionsBefore = this.actions.slice(0, idx)
            const actionsWithoutCurrent = this.actions.filter((a, i) => i !== idx)
            return actionsBefore.some(a => [
                AutomationActionOperators.APPROVE_DOCUMENT,
                AutomationActionOperators.APPROVE_DOCUMENT_MANAGER
            ].includes(this.getOperatorValue(a)) &&
                actionsWithoutCurrent.every(a => !_.get(a, 'otherwise')))
        },

        onOtherwiseToggle(idx) {
            this.onActionsSentenceChange(idx, {
                path: 'otherwise',
                data: !_.get(this.actions, [idx, 'otherwise'], false)
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '../index';
</style>
